import {
  actionCreator,
  persistentReducedStream,
  reducer,
  streamReducer,
} from '@ardoq/rxbeach';
import { ContextMenuState } from '@ardoq/context-menu';
import { ExtractStreamShape } from 'tabview/types';
import { isViewpointMode$ } from 'traversals/loadedGraph$';
import { AppModules, PayloadShowAppModule } from 'appContainer/types';
import { selectedModule$ } from 'appContainer/selectedModule$';
import { focusedChrome$ } from 'scope/focusedChrome$';
import { focusedChromeOperations } from 'scope/focusedChromeOperations';
import {
  type ContextMenuStreamShape,
  contextMenuStateOperations,
} from './contextMenuStateOperations';

export const setContextMenuState = actionCreator<ContextMenuState>(
  '[ContextMenuStateActions] set context menu state'
);

const updateViewpointMode = (
  state: ContextMenuStreamShape,
  { isViewpointMode }: ExtractStreamShape<typeof isViewpointMode$>
) => contextMenuStateOperations.setViewpointMode(state, isViewpointMode);

const updateSelectedModule = (
  state: ContextMenuStreamShape,
  { selectedModule }: PayloadShowAppModule
) => contextMenuStateOperations.setSelectedModule(state, selectedModule);

const EMPTY_STATE: ContextMenuStreamShape = {
  menuState: null,
  isViewpointMode: false,
  focusedChrome: focusedChromeOperations.NO_FOCUSED_CHROME,
  selectedModule: AppModules.HOME,
};
export const contextMenuState$ =
  persistentReducedStream<ContextMenuStreamShape>(
    'ContextMenuState$',
    EMPTY_STATE,
    [
      reducer(setContextMenuState, contextMenuStateOperations.setMenuState),
      streamReducer(isViewpointMode$, updateViewpointMode),
      streamReducer(
        focusedChrome$,
        contextMenuStateOperations.setFocusedChrome
      ),
      streamReducer(selectedModule$, updateSelectedModule),
    ]
  );
